module.exports = __webpack_public_path__ + "img/colour-orange.724d7683.png";